/**
 * Icon Cards — prevent navigation on static cards; action presets handled by card-actions.js.
 */
class IconCards extends HTMLElement {
  connectedCallback() {
    this._onClick = this._onClick.bind(this);
    this.querySelectorAll('.icon-card--static').forEach((card) => {
      card.addEventListener('click', this._onClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('.icon-card--static').forEach((card) => {
      card.removeEventListener('click', this._onClick);
    });
  }

  _onClick(event) {
    if (event.target.closest('a.icon-card__link')) {
      return;
    }
    event.preventDefault();
  }
}

if (!customElements.get('icon-cards')) {
  customElements.define('icon-cards', IconCards);
}
